<template>
    <section id="toc">
        <h1 class="print-title">CONTENTS</h1>
        <div class="toc-center">
            <div v-for="item in items" :key="item.id" class="toc-row">
                <a :href="`#${item.id}`" class="toc-item">{{ item.name }}</a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "TableOfContents",
    data() {
        return {
            items: [
                {
                    name: "Abbreviations used in this Volume",
                    id: "abbreviations",
                },
                {
                    name: "Imported Horses",
                    id: "imported-horses",
                },
                {
                    name: "Broodmares with their Produce",
                    id: "broodmares",
                },
                {
                    name: "Stallions with their Progeny",
                    id: "stallions",
                },
                {
                    name: "Exported Horses",
                    id: "exported-horses",
                },
                {
                    name: "Horses reported to have died",
                    id: "dead-horses",
                },
                // {
                //     name: "Corrections to LYSB Volume",
                //     id: "corrections",
                // },
                {
                  name: "Breeders",
                  id: "breeders",
                },
                {
                    name: "Alphabetical Index",
                    id: "index",
                },

            ],
        };
    },
};
</script>

<style lang="scss">
@media print {
    .toc-center {
        max-width: 500px;
        margin: 0 auto;
        padding-top: 40px;
        position: relative;
        &:before {
            content: "Page";
            position: absolute;
            top: 15px;
            right: -30px;
            font-weight: bold;
        }
    }

    .toc-row {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        margin: 0.5rem 0;
        width: 100%;
    }

    .toc-item {
        display:flex;
        text-decoration: none;
        color: inherit;
        width: 100%;
        font-weight: bold;
        &:after {
            content: " " target-counter(attr(href url), page);
            margin-left: auto;
            padding-left: 2rem;
            font-weight: normal;
        }
    }
}

</style>
